'use client';
import { useRemoteMedia } from './useRemoteMedia';

export const useRemoteScreenShare = (props: {
  peerId: string;
  onClose?: () => void;
  onPlayable?: (data: {
    track: MediaStreamTrack;
    stream: MediaStream;
    label: 'screen-share-video' | 'screen-share-audio';
  }) => void;
}) => {
  const {
    state,
    stream: videoStream,
    track: videoTrack,
  } = useRemoteMedia({
    label: 'screen-share-video',
    peerId: props.peerId,
    onClose: props.onClose,
    onPlayable: (data) => {
      props.onPlayable?.({
        label: 'screen-share-video',
        track: data.track,
        stream: data.stream,
      });
    },
  });

  const { stream: audioStream, track: audioTrack } = useRemoteMedia({
    label: 'screen-share-audio',
    peerId: props.peerId,
    onClose: props.onClose,
    onPlayable: (data) => {
      props.onPlayable?.({
        label: 'screen-share-audio',
        track: data.track,
        stream: data.stream,
      });
    },
  });

  return {
    videoStream,
    audioStream,
    videoTrack,
    audioTrack,
    state,
  };
};
